/* Milaros · B2B-Formular (Projektbrief) — 07.10.2026; Partneranfrage entfernt 13.10.2026
   Progressive Enhancement: ohne JS sind alle Felder sichtbar und das echte
   Shopify-Kontaktformular funktioniert. Mit JS: Schritte (nur .mlb-flow--steps),
   Prüfung je Schritt, Live-Zusammenfassung, Berlin-Hinweis zur Montage,
   Entwurf in sessionStorage (geht beim Zurück-/Neuladen nicht verloren, wird nach
   dem Absenden gelöscht) und eine lesbare Zusammenfassung in contact[body]. */
(function () {
  'use strict';
  var MAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function $all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  // Berliner PLZ 10115–14199; 12529 (Schönefeld) liegt in Brandenburg.
  function isBerlin(plz) { var n = parseInt(plz, 10); return /^\d{5}$/.test(plz) && n >= 10115 && n <= 14199 && n !== 12529; }

  function init(form) {
    var scope = form.closest('.mlb') || document;
    var steps = $all(form, '.mlb-step[data-step]');
    var stepMode = form.classList.contains('mlb-flow--steps') && steps.length > 1;
    var cur = 0;
    var key = 'mlb:' + (form.id || 'form');
    var titleEl = form.querySelector('[data-mlb-steptitle]');
    var numEl = form.querySelector('[data-mlb-stepnum]');
    var totEl = form.querySelector('[data-mlb-steptotal]');
    var bar = form.querySelector('[data-mlb-bar]');
    var back = form.querySelector('[data-mlb-back]');
    var next = form.querySelector('[data-mlb-next]');
    var heading = form.closest('.mlb-card') || form;
    $all(form, '[data-mlb-req], [data-mlb-berlin], [data-mlb-count]').forEach(function (g, i) {
      var er = g.querySelector(':scope > .mlb-err');
      if (!er) return;
      if (!er.id) er.id = (form.id || 'mlb') + '-gerr-' + i;
      g.setAttribute('aria-describedby', er.id);
      er.setAttribute('aria-live', 'polite');
    });

    /* ── Werte lesen ── */
    function groupValue(el) {
      if (el.matches('input, textarea, select')) return el.value.trim();
      if (el.hasAttribute('data-mlb-count')) {
        var op = el.querySelector('[data-mlb-count-open]'), n = el.querySelector('input[type="number"]');
        return op && op.checked ? 'noch offen' : (n && n.value ? n.value : '');
      }
      var checked = $all(el, 'input:checked');
      return checked.map(function (i) { return i.getAttribute('data-v') || i.value; }).join(', ');
    }
    function active(el) { return !el.closest('[hidden]'); }
    function briefRows() {
      return $all(form, '[data-brief]').filter(active).map(function (el) {
        var v = groupValue(el);
        if (el.tagName === 'TEXTAREA' && v.length > 160) v = v.slice(0, 157) + ' …';
        return { k: el.getAttribute('data-brief'), v: v };
      }).filter(function (r) { return r.v; });
    }
    function briefText(full) {
      var rows = $all(form, '[data-brief]').filter(active).map(function (el) { return { k: el.getAttribute('data-brief'), v: groupValue(el) }; })
        .filter(function (r) { return r.v; });
      var head = 'Projektbrief';
      return head + ' (milaros.de)\n' + rows.map(function (r) { return r.k + ': ' + (full ? r.v : r.v.replace(/\s+/g, ' ')); }).join('\n');
    }

    /* ── Zusammenfassung ── */
    function renderBrief() {
      var rows = briefRows();
      $all(scope, '[data-mlb-brief-list]').forEach(function (dl) {
        dl.textContent = '';
        if (!rows.length) {
          var d0 = document.createElement('div'), t0 = document.createElement('dt'), v0 = document.createElement('dd');
          t0.textContent = 'Noch leer'; v0.textContent = 'Ihre Auswahl erscheint hier.'; v0.className = 'is-empty';
          d0.appendChild(t0); d0.appendChild(v0); dl.appendChild(d0); return;
        }
        rows.forEach(function (r) {
          var d = document.createElement('div'), t = document.createElement('dt'), v = document.createElement('dd');
          t.textContent = r.k; v.textContent = r.v; d.appendChild(t); d.appendChild(v); dl.appendChild(d);
        });
      });
    }

    /* ── Montage-Hinweis nach PLZ ── */
    var plz = form.querySelector('[name="contact[PLZ Projekt]"]');
    function montageNote() {
      var notes = $all(form, '[data-mlb-mnote]');
      var v = plz ? plz.value.trim() : '';
      var mode = /^\d{5}$/.test(v) ? (isBerlin(v) ? 'berlin' : 'outside') : 'base';
      notes.forEach(function (n) { n.hidden = n.getAttribute('data-mlb-mnote') !== mode; });
      // Montage gibt es nur in Berlin → die Frage erscheint (und ist Pflicht) nur dort
      $all(form, '[data-mlb-berlin]').forEach(function (q) {
        var on = mode === 'berlin';
        q.hidden = !on;
        if (on) q.setAttribute('data-mlb-req', '');
        else {
          q.removeAttribute('data-mlb-req'); var er = errFor(q); if (er) er.hidden = true; q.removeAttribute('aria-invalid');
          // PLZ außerhalb Berlins: eine frühere Montage-Antwort gilt nicht mehr
          $all(q, 'input:checked').forEach(function (r) { r.checked = false; });
        }
      });
    }

    /* ── Prüfung ── */
    function setErr(holder, err, bad) {
      if (err) err.hidden = !bad;
      if (holder.matches('input, textarea')) { if (bad) holder.setAttribute('aria-invalid', 'true'); else holder.removeAttribute('aria-invalid'); }
      else if (bad) holder.setAttribute('aria-invalid', 'true'); else holder.removeAttribute('aria-invalid');
    }
    function fieldOk(el) {
      var v = el.value.trim();
      if (el.type === 'email') return MAIL.test(v);
      if (el.getAttribute('pattern')) return new RegExp('^(?:' + el.getAttribute('pattern') + ')$').test(v);
      return v.length > 0;
    }
    function errFor(el) {
      var id = el.getAttribute('aria-describedby');
      return id ? document.getElementById(id) : el.querySelector(':scope > .mlb-err');
    }
    function validate(container) {
      // Reihenfolge wie auf der Seite: Fokus springt zum ERSTEN Fehler von oben
      var items = $all(container, '[data-mlb-req], [data-mlb-count], input[required], textarea[required]');
      var first = null;
      items.forEach(function (el) {
        if (el.hasAttribute('data-mlb-count')) {
          var n = el.querySelector('input[type="number"]'), op = el.querySelector('[data-mlb-count-open]');
          var nv = n ? Number(n.value) : NaN;
          var okc = (op && op.checked) || (n && Number.isInteger(nv) && nv >= 1 && nv <= 9999);
          var er = errFor(el); if (er) er.hidden = okc;
          if (n) { if (okc) n.removeAttribute('aria-invalid'); else n.setAttribute('aria-invalid', 'true'); }
          if (!okc && !first) first = n;
          return;
        }
        var group = !el.matches('input, textarea');
        var ok = group ? !!el.querySelector('input:checked') : fieldOk(el);
        setErr(el, errFor(el), !ok);
        if (!ok && !first) first = group ? el.querySelector('input') : el;
      });
      return first;
    }
    // Fehler verschwinden, sobald korrigiert wird
    form.addEventListener('change', function (e) {
      var g = e.target.closest('[data-mlb-req]');
      if (g && g.getAttribute('aria-invalid') && g.querySelector('input:checked')) setErr(g, errFor(g), false);
    });
    $all(form, 'input[required], textarea[required]').forEach(function (el) {
      el.addEventListener('blur', function () { if (el.value.trim() || el.hasAttribute('aria-invalid')) setErr(el, errFor(el), !fieldOk(el)); });
      el.addEventListener('input', function () { if (el.hasAttribute('aria-invalid') && fieldOk(el)) setErr(el, errFor(el), false); });
    });

    /* ── Schritte ── */
    function show(i, focus) {
      cur = Math.max(0, Math.min(i, steps.length - 1));
      steps.forEach(function (s, j) { s.classList.toggle('is-current', j === cur); });
      form.classList.toggle('is-last', cur === steps.length - 1);
      if (titleEl) titleEl.textContent = steps[cur].getAttribute('data-title') || '';
      if (numEl) numEl.textContent = cur + 1;
      if (totEl) totEl.textContent = steps.length;
      if (bar) bar.style.width = Math.round((cur + 1) / steps.length * 100) + '%';
      if (back) back.hidden = cur === 0;
      if (focus) {
        var r = heading.getBoundingClientRect();
        if (r.top < 70 || r.top > window.innerHeight * 0.6) heading.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        var lg = steps[cur].querySelector('legend');
        if (lg) lg.focus({ preventScroll: true });
      }
      save();
    }
    if (stepMode) {
      form.classList.add('is-steps');
      if (next) next.addEventListener('click', function () {
        var bad = validate(steps[cur]);
        if (bad) { bad.focus(); return; }
        show(cur + 1, true);
      });
      if (back) back.addEventListener('click', function () { show(cur - 1, true); });
      // Enter in Textfeldern springt nicht vorzeitig zum Absenden
      form.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.matches('input') && cur < steps.length - 1) { e.preventDefault(); if (next) next.click(); }
      });
    }

    /* ── Entwurf (sessionStorage) ── */
    function save() {
      try {
        var data = { step: cur, v: {} };
        $all(form, 'input, textarea').forEach(function (el) {
          if (!el.name || el.type === 'hidden') return;
          if (el.type === 'radio' || el.type === 'checkbox') { if (el.checked) data.v[el.name + '|' + el.value] = 1; }
          else if (el.value) data.v[el.name] = el.value;
        });
        sessionStorage.setItem(key, JSON.stringify(data));
      } catch (e) { /* privater Modus: ohne Entwurf weiter */ }
    }
    function restore() {
      try {
        var data = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (!data) return 0;
        $all(form, 'input, textarea').forEach(function (el) {
          if (!el.name || el.type === 'hidden') return;
          if (el.type === 'radio' || el.type === 'checkbox') el.checked = !!data.v[el.name + '|' + el.value];
          else if (data.v[el.name] != null && !el.value) el.value = data.v[el.name];
        });
        return data.step || 0;
      } catch (e) { return 0; }
    }

    // Erst die Berlin-Frage ein-/ausblenden, dann die Zusammenfassung — sonst blieb nach
    // einem PLZ-Wechsel nach außerhalb Berlins die alte Montage-Antwort im Brief stehen.
    form.addEventListener('input', function () { montageNote(); renderBrief(); save(); });
    form.addEventListener('change', function () { montageNote(); renderBrief(); save(); });

    /* ── Kopieren ── */
    $all(scope, '[data-mlb-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var txt = briefText(true), label = b.querySelector('span');
        var done = function () { if (label) { var o = label.textContent; label.textContent = 'Kopiert'; setTimeout(function () { label.textContent = o; }, 1800); } };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(done, function () {});
      });
    });

    /* ── Absenden ── */
    /* Capture-Phase am Dokument: läuft VOR Shopifys hCaptcha-Listener am Formular.
       Ungültig → Ereignis komplett stoppen, sonst würde das Captcha das Formular
       nach seiner Prüfung trotzdem absenden. */
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      var bad = null, badStep = -1;
      if (stepMode) {
        for (var i = 0; i < steps.length; i++) { var b = validate(steps[i]); if (b) { bad = b; badStep = i; break; } }
      } else bad = validate(form);
      if (bad) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (stepMode && badStep !== cur) show(badStep, true);
        bad.focus();
        return;
      }
      // Gültig → Shopify (ggf. nach hCaptcha) sendet; die Nutzdaten baut der formdata-Listener.
    }, true);

    /* Nutzdaten: läuft bei JEDEM Senden — auch wenn hCaptcha das Formular später direkt
       (ohne neues submit-Ereignis) abschickt. Felder bleiben dabei unverändert bedienbar.
       Die E-Mail an den Shop enthält: Anfrage-Art, Name, E-Mail und den fertigen Brief
       (nur aktive, ausgefüllte Angaben) — keine Doppelungen, keine Leerzeilen, keine
       veralteten Werte (z. B. Montage nach PLZ-Wechsel). Ohne JS gehen die Einzelfelder. */
    var KEEP = { 'contact[Anfrage]': 1, 'contact[email]': 1, 'contact[name]': 1 };
    form.addEventListener('formdata', function (e) {
      var fd = e.formData, drop = [];
      fd.forEach(function (v, k) { if (k.indexOf('contact[') === 0 && !KEEP[k]) drop.push(k); });
      drop.forEach(function (k) { fd.delete(k); });
      fd.set('contact[body]', briefText(true));
    });

    /* ── Anzahl: − / + und „Noch offen“ ── */
    $all(form, '[data-mlb-count]').forEach(function (g) {
      var n = g.querySelector('input[type="number"]'), op = g.querySelector('[data-mlb-count-open]');
      $all(g, '[data-mlb-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(n.value, 10) || 0;
          v = Math.min(9999, Math.max(1, v + parseInt(b.getAttribute('data-mlb-step'), 10)));
          n.value = v; if (op) op.checked = false;
          n.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });
      if (op) op.addEventListener('change', function () { if (op.checked) n.value = ''; });
      n.addEventListener('input', function () { if (n.value && op) op.checked = false; });
    });

    /* ── Vorauswahl aus dem Seitenkopf / der Selbstauswahl ── */
    $all(scope, '[data-mlb-preset]').forEach(function (a) {
      a.addEventListener('click', function () {
        var name = a.getAttribute('data-mlb-preset-name') || 'contact[Projektart]';
        var val = a.getAttribute('data-mlb-preset');
        $all(form, 'input[type="radio"]').forEach(function (r) {
          if (r.name === name && r.value === val) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
        });
        if (stepMode) show(0, false);
        // nach dem Sprung: Fokus auf die nächste offene Frage
        setTimeout(function () {
          var nx = stepMode ? steps[0].querySelector('#mlb-anzahl') : form.querySelector('input[required]');
          if (nx) nx.focus({ preventScroll: true });
        }, 450);
      });
    });

    /* ── Start ── */
    var start = restore();
    var err = form.querySelector('[data-mlb-error]');
    if (stepMode) show(err ? steps.length - 1 : start, false);
    montageNote(); renderBrief();
    if (err) { err.scrollIntoView({ block: 'center' }); err.focus({ preventScroll: true }); }
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('form.mlb-flow')).forEach(init);
    var done = document.querySelector('[data-mlb-done]');
    if (done) {
      try { Object.keys(sessionStorage).forEach(function (k) { if (k.indexOf('mlb:') === 0) sessionStorage.removeItem(k); }); } catch (e) {}
      done.scrollIntoView({ block: 'center' }); done.focus({ preventScroll: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
